import Base from '.././../ts/_base';

export default class Landing extends Base  {

    private icon: HTMLElement
    private window: HTMLElement
    private nav: HTMLElement

    get ChildSelectors(): {[key: string]: string} {
        return {
            ...this.selectors,
            icon: '.landing-scroll-icon',
            nav: '#mainNavbar'
        }
    }  

    public initialize(): void {
        this.icon = this.queryElm(this.ChildSelectors.icon) as HTMLElement
        this.window = this.queryElm(this.ChildSelectors.window) as HTMLElement
        this.nav = this.queryElm(this.ChildSelectors.nav) as HTMLElement
        this.windowResize();
        this.control();

    }
    protected control(): void {
        this.icon?.addEventListener('click', this.scrollWindow);
    }
        
    protected windowResize(): void {
        const elementNav = this.nav;
        const elementIcon = this.icon;

        function addClassList() {
            //elementNav.classList.add("dark-header-nav");

            if(elementIcon) {
                elementIcon.classList.add("d-block"); 
            }
        }

        function removeClassList() {
            //elementNav.classList.remove("dark-header-nav");
            if(elementIcon) {
                elementIcon.classList.remove("d-block"); 
            }
        }

        if (window.innerHeight < 650) {
            addClassList();
        }
        else {
            removeClassList ();
        }
        window?.addEventListener('resize',  function(e) {
            if (this.innerHeight < 650) {
                addClassList();
            }
            else {
                removeClassList ();
            }
       });
    }
    protected scrollWindow(): void {
        window.scroll({
            top: 600,
            behavior: 'smooth'
        });    
    }
}

